import { AgencyBundleType, ServerAgencyInformationRequestType } from './types';

export const transformSaveAgencyBundleRequest = (
  data: AgencyBundleType
): ServerAgencyInformationRequestType => {
  return {
    insuranceProducts: [
      {
        agencyInformation: {
          agencyBundle: {
            policyType: data.policyType,
            carrier: data.policyType === 'none' ? '' : data.carrier,
          },
        },
        productType: 'personalAuto',
      },
    ],
  };
};
